import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  scrollBox: {
    width: '100%',
    height: '360px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  listItem: {
    borderBottom: '1px solid #2C2D3E4D',
    padding: '8px 0',
  },
  emptyMessage: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#2C2D3E',
    marginTop: '12px',
  },
}));
